
const keyword = [
    "Taylor",
    "apple",
    "delightful",
    "Valentino Rossi",
    "Spy Ninjas",
    "Egg Sitter",
    "HULA HOOP",
    "Tetris",
    "Polo",
    "100%",
    "AXE",
    "airpods",
    "adidas",
    "apple",
    "amazon",
    "babyliss",
    "band-aid",
    "Beats",
    "Black & Decker",
    "bluetooth",
    "Canon",
    "Chanel",
    "cheetos",
    "Coke",
    "Converse",
    "crocs",
    "Dyson",
    "eBay",
    "Epson",
    "Facebook",
    "Ferrari",
    "Fitbit",
    "Google",
    "GoPro",
    "Gucci",
    "Hanes",
    "Heinz",
    "HP",
    "IKEA",
    "iPhone",
    "iPad",
    "Instagram",
    "Intel",
    "Lego",
    "Levi's",
    "Lipton",
    "Nike",
    "Oakley",
    "Oreo",
    "Pandora",
    "PayPal",
    "Phillips",
    "Pampers",
    "PlayStation",
    "Puma",
    "Ray-Ban",
    "Reebok",
    "Samsung",
    "Scotch",
    "Sharpie",
    "Sony",
    "Starbucks",
    "Target",
    "TikTok",
    "Tupperware",
    "Twitter",
    "Under Armour",
    "Victoria's Secret",
    "Visa",
    "Walmart",
    "WD-40",
    "Xbox",
    "Xerox",
    "YouTube",
    "Ziploc",



];
export default keyword;
